import { getHeadersWithToken } from "./api";
import { FormManager } from "./formManager"

export function initAccount() {
    document.addEventListener('DOMContentLoaded', function () {
        if (document.querySelector('.account-detail')) {
            initProfileImage();
            initAccountDetail();
            initUpdatePassword();
        }
    });
}

function initProfileImage() {
    const accountProfileImage = document.getElementById('accountProfileImage');
    const accountProfileInitials = document.getElementById('accountProfileInitials');
    const addImageLink = document.getElementById('addImageLink');
    const editImageLink = document.getElementById('editImageLink');
    const deleteImageLink = document.getElementById('deleteImageLink');
    const form = document.getElementById('profileImageForm');
    const fileInput = document.getElementById('profileImage');
    const resultDiv = document.getElementById('uploadResult');

    fileInput.style.display = 'none';

    // show the upload image form (when adding)
    addImageLink.addEventListener('click', function () {
        fileInput.click();
    });
    editImageLink.addEventListener('click', function () {
        fileInput.click();
    });

    fileInput.addEventListener('change', function () {
        if (fileInput.files.length > 0) {
            form.dispatchEvent(new Event('submit', { cancelable: true }));
        }
    });


    // delete the profile image
    deleteImageLink.addEventListener('click', function () {
        if (!window.confirm('Are you sure you want to delete your profile image?')) {
            return;
        }

        getHeadersWithToken({
                'Accept': 'application/json'
            })
            .then(headers => fetch('/api/Accounts/My/Profile/Image', {
                method: 'DELETE',
                headers: headers
            }))
            .then(response => {
                if (response.ok) {
                    // update image, show add link, hide edit/delete links
                    accountProfileImage.src = '';
                    accountProfileImage.style.display = 'none';
                    accountProfileInitials.style.display = 'flex';
    
                    addImageLink.style.display = 'inline-block';
                    editImageLink.style.display = 'none';
                    deleteImageLink.style.display = 'none';
                } else {
                    console.error('Error deleting profile image:', response);
                }
            })
            .catch(error => {
                console.error('Error deleting profile image:', error);
            });
    });

    // new image form upload
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (fileInput.files.length === 0) {
            resultDiv.textContent = "Please select a file.";
            return;
        }

        const formData = new FormData();
        formData.append("file", fileInput.files[0]);

        getHeadersWithToken()
            .then(headers => fetch('/api/Accounts/My/Profile/Image', {
                method: 'POST',
                body: formData,
                headers: headers
            }))
            .then(response => {
                if (response.status === 201) {
                    accountProfileImage.src = response.headers.get("Location");
                    accountProfileImage.style.display = 'block';
                    accountProfileInitials.style.display = 'none';
    
                    form.style.display = 'none';
                    addImageLink.style.display = 'none';
                    editImageLink.style.display = 'inline-block';
                    deleteImageLink.style.display = 'inline-block';
                } else {
                    return response.text().then(text => {
                        resultDiv.textContent = "Upload failed: " + text;
                    });
                }
            })
            .catch(error => {
                resultDiv.textContent = "Error: " + error;
            });
    });
}

function initAccountDetail() {
    // show/hide the password form
    document.getElementById('updatePasswordLink').addEventListener('click', function () {
        this.style.display = 'none';
        document.getElementById('updatePasswordDiv').style.display = 'block';
        const form = document.getElementById('updatePasswordForm');
        if (form) {
            FormManager.clearFormState(form);
        }
    });

    // hide the password form
    document.getElementById('cancelUpdatePassword').addEventListener('click', function () {
        document.getElementById('updatePasswordDiv').style.display = 'none';
        document.getElementById('updatePasswordLink').style.display = 'block';
        const form = document.getElementById('updatePasswordForm');
        if (form) {
            form.reset();
            FormManager.clearFormState(form);
        }
    });

    // dynamically post the account detail form
    const form = document.getElementById('accountDetailForm');
    if (form) {
        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            await FormManager.postForm(form, '/api/Accounts/My/Profile', "Account Details", function (result) {
                if (result.success) {
                    // Success handled by FormManager
                } else {
                    console.error(result.error);
                }
            });
        });
    }
}

function initUpdatePassword() {
    // show/hide the password form
    document.getElementById('updatePasswordLink').addEventListener('click', function () {
        this.style.display = 'none';
        document.getElementById('updatePasswordDiv').style.display = 'block';
        const form = document.getElementById('updatePasswordForm');
        if (form) {
            FormManager.clearFormState(form);
        }
    });

    // hide the password form
    document.getElementById('cancelUpdatePassword').addEventListener('click', function () {
        document.getElementById('updatePasswordDiv').style.display = 'none';
        document.getElementById('updatePasswordLink').style.display = 'block';
        const form = document.getElementById('updatePasswordForm');
        if (form) {
            form.reset();
            FormManager.clearFormState(form);
        }
    });

    const eyeIcons = document.querySelectorAll('.account-detail__eye-icon');
    eyeIcons.forEach(icon => {
        icon.addEventListener('click', function () {
            const input = this.previousElementSibling;
            if (input.type === 'password') {
                input.type = 'text';
                this.src = '/images/eye-icon-hide.svg';
                this.alt = 'Hide password';
            } else {
                input.type = 'password';
                this.src = '/images/eye-icon.svg';
                this.alt = 'Show password';
            }
        });
    });

    // dynamically post the password form
    const form = document.getElementById('updatePasswordForm');
    if (form) {
        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            await FormManager.postForm(form, '/api/Accounts/ChangePassword', "Password", function (result) {
                if (result.success) {
                    // Success handled by FormManager
                } else {
                    console.error(result.error);
                }
            });            
        });
    }
}